import {
  updateMultipleVisibility,
  updateVisibility,
  useDataTemplate,
} from 'components/form_builder/features/data/dataSlice'
import { isEqual } from 'lodash'
import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SectionDivider from '../SectionDivider'
import { OverrideWarning } from './PathForMultipleFields'
import ConditionalControls from '../ConditionalControls'

const OPTIONS = {
  ALWAYS: 'always',
  CONDITIONALLY: 'conditionally',
}

export const MultipleVisibility = ({ shareComponent, components }) => {
  const template = useDataTemplate(shareComponent.type, shareComponent.id)
  const dispatch = useDispatch()

  const data = useSelector((state) => state.data)
  const commonVisibility = data[shareComponent.type]?.[shareComponent.id]?.if

  const isUniform = useMemo(() => {
    if (!components || components.length === 0) return true

    return components.slice(1).every((component) => {
      const { type, id } = component
      const visibility = data[type]?.[id]?.if
      if (typeof visibility === 'boolean') return visibility === commonVisibility
      return isEqual(visibility, commonVisibility)
    })
  }, [components, commonVisibility, data])

  const handleUpdate = (visibility) => dispatch(updateMultipleVisibility({ components, visibility }))

  return (
    <SectionDivider sectionName="visibility">
      {!isUniform ? (
        <OverrideWarning onOverride={() => handleUpdate(true)} />
      ) : (
        <ConditionalControls initialValue={commonVisibility} onUpdate={handleUpdate} />
      )}
    </SectionDivider>
  )
}

export default function Visibility({ component }) {
  const dispatch = useDispatch()
  const { type, id } = component
  const template = useDataTemplate(type, id)

  const handleUpdate = (visibility) => dispatch(updateVisibility({ id, type, visibility }))

  return (
    <SectionDivider sectionName="visibility">
      <ConditionalControls initialValue={template.if} options={OPTIONS} onUpdate={handleUpdate} />
    </SectionDivider>
  )
}
